<tax-page-header
  [titleText]="isEditForm ? 'kkm.settings.retail.place' : 'retail.place.add'"
></tax-page-header>

<div class="alert" *ngIf="isRcaNormalizationProcess">
  <tax-icon name="alert"></tax-icon>
  <div class="alert-message" data-qa="alert-message">
    <p *ngFor="let paragraph of alertMessage | translate | taxTextSeparator: '.'">
      <span
        *ngFor="let word of paragraph | taxTextSeparator: ' '"
        [class.highlighted-word]="['заново', 'қайта'].includes(word.trim())"
        >{{ word }}</span
      >
    </p>
  </div>
</div>

<form class="ui-kit-content-container" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm">
  <div class="wrapper ui-kit-rows-layout">
    <tax-input
      id="title"
      data-qa-input="retail-place-name"
      labelText="retail.place.title"
      name="title"
      placeholder="retail.place.title.placeholder"
      [(ngModel)]="retailPlace.retailPlaceTitle"
      [required]="true"
      [autofocus]="true"
      [layoutColumns]="2"
      [clearable]="true"
    ></tax-input>

    <div class="ui-kit-layout-columns-2" data-qa-select="region">
      <label for="region" class="required-marker" translate data-qa="label-text"
        >retail.place.region</label
      >
      <tax-search-dropdown-list
        id="region"
        tabindex="2"
        data-qa="select"
        [currentItem]="retailPlace.retailPlaceAddress.region"
        [callback]="getRegion.bind(this)"
        (submittedData)="setRegion($event)"
      ></tax-search-dropdown-list>
    </div>

    <div class="ui-kit-layout-columns-2" data-qa-select="city">
      <label for="city" class="required-marker" translate data-qa="label-text"
        >retail.place.city</label
      >
      <tax-search-dropdown-list
        id="city"
        data-qa="select"
        [currentItem]="retailPlace.retailPlaceAddress.city"
        [disabled]="!retailPlace.retailPlaceAddress.region"
        [callback]="getCity.bind(this)"
        (submittedData)="setCity($event)"
      ></tax-search-dropdown-list>
    </div>

    <div class="ui-kit-layout-columns-2" data-qa-select="street">
      <label for="street" class="required-marker" data-qa="label-text">{{
        'retail.place.street' | translate
      }}</label>
      <tax-search-dropdown-list
        id="street"
        data-qa="select"
        placeholder="retail.place.street.placeholder"
        [manualInputText]="isIsnaEnabled ? '' : 'select.manual.input.text'"
        [currentItem]="retailPlace.retailPlaceAddress.street"
        [callback]="getStreet.bind(this)"
        [disabled]="!retailPlace.retailPlaceAddress.city"
        [manualInput]="manualInputStreet"
        (submittedData)="setStreet($event)"
        (selectManualInput)="openManualInputAddressModal()"
        (cleanEvent)="setStreet()"
      ></tax-search-dropdown-list>
    </div>

    <div class="ui-kit-layout-columns-2" data-qa-select="street">
      <label for="house" class="required-marker" data-qa="label-text">{{
        'retail.place.house' | translate
      }}</label>
      <tax-search-dropdown-list
        id="house"
        data-qa="select"
        placeholder="retail.place.house.placeholder"
        style="max-width: 344px"
        helpText="kkms.retail.place.create.form.house.help"
        [manualInputText]="isIsnaEnabled ? '' : 'select.manual.input.text'"
        [currentItem]="retailPlace.retailPlaceAddress.house"
        [disabled]="!retailPlace.retailPlaceAddress.street"
        [manualInput]="manualInputHouse"
        [callback]="getHouse.bind(this)"
        (submittedData)="setHouse($event)"
        (selectManualInput)="
          openManualInputAddressModal(this.retailPlace.retailPlaceAddress.street ?? '')
        "
        (cleanEvent)="setHouse()"
      ></tax-search-dropdown-list>
    </div>

    <tax-input
      id="apartment"
      data-qa-input="apartment"
      labelText="retail.place.apartment"
      name="apartment"
      inputStyles="max-width: 344px"
      placeholder="retail.place.apartment.placeholder"
      helpText="kkms.retail.place.create.form.apartment.help"
      patternErrorText="retail.place.apartment.pattern.error"
      [(ngModel)]="retailPlace.retailPlaceAddress.apartment"
      [disabled]="!retailPlace.retailPlaceAddress.house"
      [layoutColumns]="2"
      [clearable]="true"
      [pattern]="retailPlace.retailPlaceRegex?.apartment ?? ''"
    ></tax-input>
  </div>

  <div class="ui-kit-bottom-buttons-block">
    <button class="back-button" data-qa-button="go-back" (click)="goBack()" type="button">
      {{ 'group.back' | translate }}
    </button>
    <div>
      <button class="button_blue" data-qa-button="save-retail-place" [disabled]="!formValidation()">
        {{ (isEditForm ? 'button.save' : 'group.save') | translate }}
      </button>
    </div>
  </div>
</form>
